import React from "react";
import "./styles/ErrorBoundary.css";

/**
 * App-root error boundary: friendly fallback card with reload.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface in devtools; no telemetry by design.
    console.error("InsightBoard crashed:", error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <div className="error-card">
            <h2>Something went wrong</h2>
            <p>
              The dashboard hit an unexpected error. Your watchlist and
              preferences are saved locally and will be restored.
            </p>
            <button type="button" className="btn-reload" onClick={this.handleReload}>
              Reload dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
